import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { DeflectionCalcService } from '../services/deflection-calc.service';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'deflect-weak',
  standalone: true,
  
  templateUrl: './deflect-weak.component.html',
  styleUrl: './deflect-weak.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButtonModule
  ]
})
export class DeflectWeakComponent {

  rpe_dw_form: FormGroup;
  osmBool: boolean = false;
  m1V: number = 0;
  kV: number = 0;
  daV: number = 0;
  osMap: Map<string, number> = new Map();


  constructor(private osService: DeflectionCalcService, private fBuilder: FormBuilder) {
        this.rpe_dw_form = this.fBuilder.group({
          kVal: ['', [
            Validators.required,
            Validators.min(1.000001),
            Validators.max(1.67),
          ]],
          m1Val: '',
          daVal: '',
        });
  }


  onSubmit() {

    if (this.rpe_dw_form.valid) {

      this.osmBool = true;

      const kValControl = this.rpe_dw_form.get('kVal');
      this.kV = kValControl ? kValControl.value : 0;
      
      console.log(this.kV);

      const m1ValControl = this.rpe_dw_form.get('m1Val');
      this.m1V= m1ValControl ? m1ValControl.value : 0;
      
      const daValControl = this.rpe_dw_form.get('daVal');
      this.daV = daValControl ? daValControl.value : 0;

      let weak: boolean = true;
      
      this.osMap = this.osService.getObliqueShock(this.kV, this.m1V, this.daV, weak);
    }
  }


  osTheta() {
    return this.osMap.get("theta");
  }

  osM2() {
    return this.osMap.get("M2");
  }


}
